var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((_vm.value),function(el,i){return _c('span',{key:el.key},[_c('Link',_vm._b({attrs:{"row":el,"value":el,"options":el.options || _vm.options}},'Link',el,false)),(i != _vm.value.length - 1)?_c('span',[_vm._v(", ")]):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }